/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
"use client";

import { SetStateAction, useEffect, useState } from "react";
import NewSelectInput from "../../../components/NewSelectInput";
import NormalSearch from "../../../components/common/NormalSearch";
import { IconRefresh } from "@tabler/icons-react";
import NewinputField from "../../../components/NewInput";
import { Control, useForm, UseFormClearErrors } from "react-hook-form";
import TextareaField from "../../../components/common/TextareaField";
import { useMerchantAllListData } from "../../../apis/merchantApis";
import {
  useFetchLmClientOrdersData,
  usePickupLocationClientAddressData,
  usePickupLocationtAlltData,
} from "../../../apis/pickupApis";
import ProductTable from "../../DRSManagement/_components/ProductTable";
import { use } from "i18next";
import Pagination from "../../../components/common/Pagination";
import { totalmem } from "os";
import InputField from "../../../components/common/InputField";
import { useLanguage } from "../../../context/LanguageContext";

const vehicleTypes = [
  { id: 1, value: "car", text: "Car" },
  { id: 2, value: "van", text: "Van" },
  { id: 3, value: "dokker", text: "DoKker" },
];

const RequestTypeData = [
  { id: 1, value: "Shipment", text: "Request with Shipment" },
  { id: 2, value: "NonShipment", text: "Request without Shipment" },
];

type Props = {
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  clearErrors?: UseFormClearErrors<any>;
  control: Control<any>; // ✅ Add this
  reset?: any;
  // setSelectedOrders: React.Dispatch<React.SetStateAction<string[]>>;
  // selectedOrders: string[];
};

const ReverseProductData = [
  {
    sku: "SKU001",
    id: 1,
    itemName: "Sony WH-1000XM5 Headphones",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    weight: "5 kg",
    selected: false,
    image: "/images/products/headphones-orange.png",
  },
  {
    sku: "SKU002",
    id: 2,
    itemName: "Sony WH-1000XM5 Headphones",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    weight: "2 kg",
    selected: true,
    image: "/images/products/headphones-green.png",
  },
  {
    sku: "SKU010",
    id: 3,
    itemName: "Sony WH-1000XM5 Headphones",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    weight: "3 kg",
    selected: false,
    image: "/images/products/headphones-yellow.png",
  },
  {
    sku: "SKU123",
    id: 4,
    itemName: "Sony WH-1000XM5 Headphones",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    weight: "1.5 kg",
    selected: false,
    image: "/images/products/headphones-pink.png",
  },
];

const ReverseToInventory = ({
  register,
  errors,
  setValue,
  watch,
  control,
  reset,
  clearErrors,
}: // selectedOrders,
// setSelectedOrders,
Props) => {
  const { t } = useLanguage();
  const [awbText, setAwbText] = useState("");
  const [searchFor, setSearchFor] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loadOrder, setLoadOrder] = useState(false);

  // const { register, handleSubmit } = useForm();
  const { data: clients } = useMerchantAllListData();
  const { data: pickupLocations } = usePickupLocationtAlltData();
  const { data: clientAddresses } = usePickupLocationClientAddressData(
    watch("clientId") || ""
  );
  const { data: ClientOrders, refetch } = useFetchLmClientOrdersData(
    pageNo,
    limit,
    searchFor,
    watch("clientId") || "",
    loadOrder
  );

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const onSubmit = (data: any) => {
    console.log(data);
  };

  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState<{
    [key: number]: boolean;
  }>({
    1: false,
    2: false,
    3: false,
    4: false,
  });

  const handleSelectAll = () => {
    const newValue = !selectAll;
    setSelectAll(newValue);

    // Update all rows
    const updated = Object.keys(selectedItems).reduce((acc: any, key) => {
      acc[key] = newValue;
      return acc;
    }, {});
    setSelectedItems(updated);
  };

  const handleSelectSingle = (id: number) => {
    const updated = { ...selectedItems, [id]: !selectedItems[id] };
    setSelectedItems(updated);

    // Check if all selected
    const allChecked = Object.values(updated).every(Boolean);
    setSelectAll(allChecked);
  };

  useEffect(() => {
    setValue("requestType", "PICKUP");
  }, []);

  useEffect(() => {
    refetch();
  }, [watch("clientId")]);

  return (
    <div
      className="w-full p-3 sm:p-4 space-y-3 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-2xl"
    >
      <div className="max-h-[calc(100vh-20rem)] overflow-y-auto hide-scrollbar space-y-3">
        <div className="space-y-3">
          <InputField 
            label={t("Enter AWB")} 
            placeholder={t("Paste AWB...")} 
            className="!space-y-0.5"
          />
          <div className="overflow-x-auto hide-scrollbar w-full border border-slate-200 bg-white rounded-xl">
            <table className="w-full table-auto min-w-[600px]">
              <thead>
                <tr className="border-b border-[#D8D8D8] border-dashed bg-slate-50/50">
                  <th className="text-center p-2 text-xs font-semibold text-[#212121]/80 w-10">
                    <label className="relative flex items-center justify-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                        className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all 
                                   bg-white checked:bg-[#FBD037] checked:text-white"
                      />
                      <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                        ✓
                      </span>
                    </label>
                  </th>

                  <th className="text-center p-2 text-xs font-semibold text-[#212121]/80 w-8">
                    #
                  </th>
                  <th className="text-left p-2 text-xs font-semibold text-[#212121]/80 w-16">
                    {t("SKU")}
                  </th>

                  <th className="text-left p-2 text-xs font-semibold text-[#212121]/80">
                    {t("Item Name")}
                  </th>
                  <th className="text-center p-2 text-xs font-semibold text-[#212121]/80 w-12">
                    {t("Qty.")}
                  </th>
                  <th className="text-left p-2 text-xs font-semibold text-[#212121]/80 w-16">
                    {t("Shelf Id")}
                  </th>
                  <th className="text-center p-2 text-xs font-semibold text-[#212121]/80 w-16">
                    {t("Capacity")}
                  </th>
                  <th className="text-left p-2 text-xs font-semibold text-[#212121]/80 w-28">
                    {t("Scan Location")}
                  </th>
                  <th className="text-center p-2 text-xs font-semibold text-[#212121]/80 w-16">
                    {t("Action")}
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-slate-100">
                {ReverseProductData.map((item, i) => (
                  <tr
                    key={i}
                    className="hover:bg-[#FBD037]/10 transition cursor-pointer"
                  >
                    <td className="p-2 text-center w-10">
                      <label className="relative flex items-center justify-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={selectedItems[Number(item.id)]}
                          onChange={() => handleSelectSingle(Number(item.sku))}
                          className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] transition-all 
                                     bg-white checked:bg-[#FBD037] checked:text-white"
                        />
                        <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                          ✓
                        </span>
                      </label>
                    </td>
                    <td className="p-2 text-xs text-[#212121] text-center w-8 font-medium">
                      {i + 1}
                    </td>

                    <td className="p-2 text-xs text-[#212121] font-mono w-16 truncate">
                      {item?.sku || ""}
                    </td>

                    <td className="p-2 text-xs text-[#212121]">
                      <div className="flex items-center space-x-2 max-w-[200px] md:max-w-[240px]">
                        <img
                          src="https://encrypted-tbn2.gstatic.com/shopping?q=tbn:ANd9GcSrTRMYecyowNBRzuU_jZwSIPkEKJyj5UdzNaoO4UYWZEv6CLp72_3IQi6cs5kBaLIHug04kMh_nW_oC1veckIEc7HqKKsTij7y2lPCC59O"
                          alt="Apple Watch"
                          className="w-10 h-10 rounded-md object-cover flex-shrink-0"
                        />
                        <div className="min-w-0 flex-1">
                          <p 
                            className="text-xs font-semibold text-[#212121] capitalize truncate" 
                            title="Apple Watch Series 11 GPS + Cellular 46mm Aluminium Case"
                          >
                            Apple Watch Series 11 GPS + Cellular 46mm Aluminium Case
                          </p>
                          <p className="text-[10px] text-[#212121]/60 truncate hidden sm:block">
                            As part of our efforts to reach carbon neutrality by 2030...
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="p-2 text-xs text-[#212121] text-center w-12 font-medium">
                      2
                    </td>

                    <td className="p-2 text-xs text-[#212121] w-16 font-mono">#Bay-01234</td>
                    <td className="p-2 text-xs text-[#212121] text-center w-16 font-medium">
                      5
                    </td>

                    <td className="p-2 w-28">
                      <input
                        placeholder={t("Scan Shelve")}
                        {...register(`products.${i}.note`, {
                          required: false,
                        })}
                        className="rounded-full px-2.5 py-1 text-xs border border-[#D8D8D8] focus:outline-none w-full text-center placeholder:text-[10px]"
                      />
                    </td>

                    <td className="p-2 text-center w-16">
                      <button className="px-2.5 py-1 bg-[#FBD037] hover:bg-[#ebd037] active:scale-95 transition-all rounded-full text-xs font-semibold text-[#212121]">
                        {t("Add")}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReverseToInventory;
